import * as angular from "angular";
import { DialogUtils } from "../../../../helper/dialog.helper";
import { ChartHelper } from "../../../result/chart.helper";
import { DashboardDataProvider } from "../../../../data-provider/dashboard.dp";
import { EffortDataProvider } from "../../../../data-provider/effort.dp";
import { Effort } from "../../../../models/effort.model";
import { DashboardWidgetFilter } from "../../../../models/dashboard-widget-filter.model";
import { Dashboard } from "../../../../models/dashboard.model";
import { ResultDataProvider } from "../../../../data-provider/result.dp";
import { PermissionCheck } from "../../../../shared/permission";
import { DashboardWidget } from "../../../../models/dashboard-widget.model";
import { PermissionLevel } from "../../../../utils/constants/permission-levels.constants";

let WidgetFilterFormComponent = {
    selector: "vcWidgetFilterForm",
    templateUrl:
        "/angular/components/dashboard/widget/filter/widget-filter-form.component.html",
    bindings: {
        dashboard: "=",
        filter: "=",
        widget: "=",
        global: "=?",
    },
    controller: class WidgetFilterFormController {
        // * bindings for typescript compiler *
        public filter: DashboardWidgetFilter;
        public dashboard: Dashboard;
        public widget: DashboardWidget;
        public global: boolean;
        // ************************************

        public $scope: any;
        public __env: any;
        public dataProvider: DashboardDataProvider;
        public resultDataProvider: ResultDataProvider;
        public permissionProvider: PermissionCheck;
        public dialog: DialogUtils;
        public efforts: Effort[];
        public chartHelper: ChartHelper;
        public customTemplates;
        public isLeaderView: boolean;

        constructor(
            $scope: any,
            __app_type: string,
            __env: any,
            DialogUtils: DialogUtils,
            DashboardDataProvider: DashboardDataProvider,
            ResultDataProvider: ResultDataProvider,
            PermissionCheck: PermissionCheck,
            EffortDataProvider: EffortDataProvider,
            ChartHelper: ChartHelper
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.__env = __env;
            this.chartHelper = ChartHelper;
            this.dataProvider = DashboardDataProvider;
            this.resultDataProvider = ResultDataProvider;
            this.permissionProvider = PermissionCheck;
            this.customTemplates =
                this.resultDataProvider.getCustomDateTemplates();
            this.isLeaderView = __app_type == "LEADER";

            EffortDataProvider.getAllEfforts().then((efforts) => {
                this.efforts = efforts;
            });
        }

        $onInit(): void {
            if (
                this.widget?.type === "userTracking" &&
                (!this.filter.permissionIds ||
                    this.filter.permissionIds.length === 0)
            ) {
                this.selectAllVisibleByDefault();
            }
        }

        openUsersTeamsDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-widget-filter-users-teams-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Users or Teams Filter",
                    size: "med",
                    locals: {
                        filter: angular.copy(this.filter),
                    },
                })
                .then((filter: any): void => {
                    this.filter.setData(filter);
                });
        }

        openListsDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-widget-filter-lists-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Lists Filter",
                    size: "med",
                    locals: {
                        filter: angular.copy(this.filter),
                    },
                })
                .then((filter: any): void => {
                    this.filter.setData(filter);
                });
        }

        openDivisionsDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-widget-filter-divisions-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Divisions Filter",
                    size: "med",
                    locals: {
                        filter: angular.copy(this.filter),
                    },
                })
                .then((filter: any): void => {
                    this.filter.setData(filter);
                });
        }

        /**
         * Helper to get only the permissions the user can actually see/interact with
         */
        private getVisiblePermissions(): any[] {
            return this.permissionProvider.levels.filter(
                (p: any): boolean => !this.shouldHidePermission(p)
            );
        }

        /**
         * Logic to determine if a permission should be hidden
         */
        public shouldHidePermission(permission: PermissionLevel): boolean {
            if (permission.permissionid === 7) {
                return true;
            }
            return (
                !this.isLeaderView &&
                permission.permissiontype === "ORGANISATION"
            );
        }

        /**
         * Gets the label for the md-select
         */
        public getPermissionLabel(): string {
            const selectedCount: number = (this.filter.permissionIds || [])
                .length;
            const visibleCount: number = this.getVisiblePermissions().length;

            if (selectedCount === 0) return "None Selected";
            if (selectedCount >= visibleCount && visibleCount > 0)
                return "All Permissions";

            return `${selectedCount} Permissions Selected`;
        }

        /**
         * Handlers for the Select All checkbox
         */
        public isAllSelected(): boolean {
            const visibleIds: any[] = this.getVisiblePermissions().map(
                (p: any): any => p.permissionid
            );
            const selectedIds = this.filter.permissionIds || [];
            return (
                visibleIds.length > 0 &&
                visibleIds.every((id: any): boolean => selectedIds.includes(id))
            );
        }

        public isPartialSelected(): boolean {
            const selectedCount: number = (this.filter.permissionIds || [])
                .length;
            const visibleCount: number = this.getVisiblePermissions().length;
            return selectedCount > 0 && selectedCount < visibleCount;
        }

        public toggleAll(): void {
            if (this.isAllSelected()) {
                this.filter.permissionIds = [];
            } else {
                // Only select IDs that are currently visible
                this.filter.permissionIds = this.getVisiblePermissions().map(
                    (p: any): any => p.permissionid
                );
            }
        }

        private selectAllVisibleByDefault(): void {
            // We map only the visible permissions to their IDs
            this.filter.permissionIds = this.permissionProvider.levels
                .filter((p: any) => !this.shouldHidePermission(p))
                .map((p: any) => p.permissionid);
        }
    },
};

angular
    .module("dashboard")
    .component(WidgetFilterFormComponent.selector, WidgetFilterFormComponent);
